module.exports = __webpack_public_path__ + "img/bonus_pc_th.082794bd.png";